import Loader from '@components/shared/loader/Loader';
import { useIsAdminUser } from '@hooks/essential-ui/UseIsAdminUser';
import { clearState, isAuth0, loginCallback } from '@services/auth/AuthService';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useConfig } from '@hooks/UseConfig';
import { ErrorResponse } from 'oidc-client-ts';

const LoginPage: FC = () => {
  const { stsAuthority } = useConfig();
  const navigate = useNavigate();

  useEffect(() => {

    const loginAsync = async (): Promise<void> => {
      try {
        const user = await loginCallback();
        if (!localStorage.getItem('user')) {
          localStorage.setItem('user', JSON.stringify(user));
        }
        if (user) {
          localStorage.setItem('token', user.access_token);
        }

        const { isError } = useIsAdminUser();

        if (isError) {
          navigate('/logout');
        } else {
          navigate('/home/select', { state: { name: 'default' } });
        }
      } catch (exception) {
        console.error(exception);
        clearState();

        if (isAuth0(stsAuthority)){
          const errorMessage = (exception as ErrorResponse)?.message || "";
          if (errorMessage.includes('authority mismatch') || errorMessage.includes('no matching state'))
          {
            navigate('/logout');
          } else if (errorMessage.includes('10')) {
            navigate('/auth-error?code='+ encodeURIComponent(errorMessage));
            return;
          }

          navigate('/auth-error');
          return;
        }
        navigate('/logout');
      }
    };

    loginAsync();
  }, []);

  return <Loader />;
};

export default LoginPage;
